import { toast as sonnerToast, Toaster as SonnerToaster } from 'sonner';

export const useToast = () => {
  const toast = (options: any) => {
    sonnerToast(options);
  };

  return {
    toast,
    Toaster: SonnerToaster,
  };
};

export const ToasterGlass = () => (
  <SonnerToaster
    position="top-center"
    closeButton
    toastOptions={{
      unstyled: true,
      classNames: {
        toast:
          'flex items-center gap-2 w-full rounded-2xl border border-white/50 dark:border-white/10 shadow-[0_8px_32px_rgba(16,50,84,0.18)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.4)] pl-4 pr-11 py-3 text-sm ' +
          'bg-white/80 dark:bg-gray-900/80 ' +
          'supports-[backdrop-filter]:bg-white/60 dark:supports-[backdrop-filter]:bg-gray-900/55 ' +
          'supports-[backdrop-filter]:backdrop-blur-xl supports-[backdrop-filter]:backdrop-saturate-150 ' +
          'text-gray-900 dark:text-white',
        title: 'font-medium',
        description: 'text-gray-500 dark:text-gray-400',
        actionButton: 'bg-[#103254] text-white rounded-xl px-3 py-1.5 text-xs',
        cancelButton: 'bg-gray-200/70 dark:bg-white/10 rounded-xl px-3 py-1.5 text-xs',
        closeButton:
          'absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-1.5 transition-colors flex items-center justify-center ' +
          '[&>svg]:w-4 [&>svg]:h-4 ' +
          'text-gray-400 hover:text-gray-600 hover:bg-gray-200/60 ' +
          'dark:text-gray-500 dark:hover:text-gray-300 dark:hover:bg-white/10',
      },
    }}
  />
);